import { createPresetOnChangeHandler, findAppliedFilters } from 'utils/presets';
import { FilterAccordionItem } from 'components/FilterAccordion';
import { PiSlidersHorizontal } from 'react-icons/pi';
import PresetTooltip from 'components/PresetTooltip';
import { useTheme } from 'styled-components';

export function withPresetTooltip(Component, presets) {
    return function PresetTooltipComponent({ value, ...props }) {
        return (
            <PresetTooltip preset={value} presets={presets}>
                <Component {...props} />
            </PresetTooltip>
        );
    };
}

function PresetFilterAccordionItem({
    filters,
    setFilters,
    sortOption,
    setSortOption,
    initialSortOption,
    healthStatOptions,
    presets,
    label = 'Preset Filters',
    mixpanelContext = 'PresetFilterSelect',
    Icon = PiSlidersHorizontal,
    ...props
}) {
    const theme = useTheme();
    const options = Object.values(presets);
    const appliedFilters = findAppliedFilters({ filters, presets, sortOption });
    const onChange = createPresetOnChangeHandler({
        filters,
        setFilters,
        sortOption,
        setSortOption,
        initialSortOption,
        theme,
        presets,
    });
    return (
        <FilterAccordionItem
            appliedFilters={
                appliedFilters?.length ? appliedFilters.map((a) => a.value) : []
            }
            options={options.filter(({ filters }) => {
                return (
                    !filters.healthStats ||
                    filters.healthStats.every(({ metricLabel }) =>
                        healthStatOptions.some(
                            ({ label }) => label === metricLabel,
                        ),
                    )
                );
            })}
            onChange={onChange}
            label={label}
            mixpanelContext={mixpanelContext}
            Icon={Icon}
            {...props}
        />
    );
}

export default PresetFilterAccordionItem;
